import { PackageReleaseDetail, ReleasesSortBy } from './ReleaseList.types';

export const RELEASES_SORT_BY_VALUES = [
  'version',
  'releaseDate',
] as const satisfies readonly ReleasesSortBy[];

export const RELEASES_SORT_BY_DEFAULT: ReleasesSortBy = 'version';

export const isReleasesSortBy = (value: unknown): value is ReleasesSortBy =>
  RELEASES_SORT_BY_VALUES.includes(value as ReleasesSortBy);

const toTimestamp = (releasedAt?: string) => Date.parse(releasedAt ?? '');

export const sortReleases = (
  releases: PackageReleaseDetail[],
  sortBy: ReleasesSortBy
): PackageReleaseDetail[] => {
  if (sortBy === 'version') return releases;

  return [...releases].sort((a, b) => {
    const aTime = toTimestamp(a.releasedAt);
    const bTime = toTimestamp(b.releasedAt);
    const aMissing = Number.isNaN(aTime);
    const bMissing = Number.isNaN(bTime);

    if (aMissing || bMissing) return Number(aMissing) - Number(bMissing);
    return bTime - aTime;
  });
};
